const table110 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "surplus_reserve_addition",
        name: "利益準備金(処分額･積立額(当期の増(3)))",
        editable: false
    },
    {
        key: "surplus_reserve_deduction",
        name: "利益準備金(取崩額(当期の減(2)))",
        editable: false
    },
    {
        key: "surplus_reserve",
        name: "利益準備金",
        editable: true
    },
    {
        key: "begin_earnings_reserve",
        name: "期首連結個別利益積立金額",
        editable: true
    }
];

export { table110 };
